import { Link, Tooltip } from '@routable/gross-ds';
import React from 'react';
import { PLATFORM_DISPLAY_SHORT_NAME } from 'constants/platform';
import helpDocs from 'helpers/helpDocs';
const CurrencyNotEnabledOnLedgerTooltip = ({ children, currencyCode, isRelatedToPartnership, isShown, ledgerName, partnershipType, position = 'right', }) => {
    const partnershipText = isRelatedToPartnership ? `on this ${partnershipType} ` : '';
    const appendedText = isRelatedToPartnership
        ? '.'
        : `, and it is the currency associated with this ${partnershipType} on ${PLATFORM_DISPLAY_SHORT_NAME}.`;
    return !isShown ? (children) : (React.createElement(Tooltip, { closeDelay: 100, "data-testid": "tooltip--currency-not-enabled-on-ledger", position: position, tooltip: React.createElement("span", { className: "text-xs" },
            `${currencyCode} is not enabled as a currency option ${partnershipText}in your ${ledgerName} account${appendedText} `,
            React.createElement(Link, { href: helpDocs.PARTNER_COUNTRY_CURRENCY_HINT, openInNewTab: true }, "Learn more about how to fix this")), variant: "light" }, children));
};
export default CurrencyNotEnabledOnLedgerTooltip;
